import { useEffect, useState } from 'react'
import { NavLink, useParams } from 'react-router-dom';
import s from './verify-page.module.scss'
import { auth } from '@shared/api/services';

export const VerifyPage = () => {
	let { token } = useParams();
	const [isError, setIsError] = useState(false)
	const [loading, setLoading] = useState(true)

	useEffect(() => {
		auth.verifyEmail(token).then(res => {
			if (res.status === 200 || res.status === 204) {
				setLoading(false)
				return
			}
			setLoading(false)
		}).catch(err => {
			setIsError(true)
			setLoading(false)
		});
	}, [token])

	const getBadgeText = () => {
		if (loading) return 'Проверка';
		if (isError) return 'Ошибка';
		return 'Успешно';
	}

	const getTitle = () => {
		if (loading) return 'Проверяем ссылку…';
		if (isError) return 'Ссылка невалидна';
		return 'Почта подтверждена';
	}

	const getSubtitle = () => {
		if (loading) return 'Подождите немного, мы почти закончили';
		if (isError) return 'Похоже, ссылка устарела или была использована ранее';
		return 'Ваш адрес электронной почты успешно подтверждён. Приятного пользования платформой!';
	}

	return (
		<section className={s.wrapper}>
			<div className={s.glowTop} aria-hidden="true" />
			<div className={s.glowBottom} aria-hidden="true" />

			<div className={s.card}>
				<div className={s.badge}>{getBadgeText()}</div>

				<div className={s.visual} aria-hidden="true">
					<div className={s.vinyl}>
						<div className={s.vinylCenter} />
					</div>
					<div className={s.wave} />
					<span className={s.noteLeft}>♪</span>
					<span className={s.noteRight}>♫</span>
				</div>

				<div className={s.content}>
					<h1>{getTitle()}</h1>
					<p>{getSubtitle()}</p>
					{!loading && (
						<NavLink
							to="/"
							className={s.homeButton}
						>
							{isError ? 'На главную' : 'Вернуться на главную'}
						</NavLink>
					)}
				</div>
			</div>
		</section>
	)
}
